import { __read } from "tslib";
import React from "react";
import moment from "moment";
import Table, { CellStatus } from "./BaseTable";
import { useTranslation } from "../../i18n";
import { useConfig } from "../../_util/config-context";
import { noop } from "../../_util/noop";
import { getNow, isAfter, isBefore, isSame } from "../../datepicker/util";
export function DateTable(_a) {
    var current = _a.current, _b = _a.onCurrentChange, onCurrentChange = _b === void 0 ? noop : _b, _c = _a.onHoveredChange, onHoveredChange = _c === void 0 ? noop : _c, range = _a.range, disabledDate = _a.disabledDate, _d = _a.onSelect, onSelect = _d === void 0 ? noop : _d, _e = _a.onTypeChange, onTypeChange = _e === void 0 ? noop : _e, _f = _a.cellStatus, cellStatus = _f === void 0 ? function () { return CellStatus.Common; } : _f, dateRangeInRangePicker = _a.dateRangeInRangePicker, dateRender = _a.dateRender;
    var t = useTranslation();
    var classPrefix = useConfig().classPrefix;
    var month = current.month();
    var now = getNow(current);
    function genTable() {
        var table = [];
        // 本月第一天
        // 从 current clone 保持 value 的时区等信息
        var first = moment(current).set({
            date: 1,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
        });
        var firstDay = first.day();
        // 第一周
        var firstWeek = Array(7)
            .fill(null)
            .map(function (_, i) { return first.clone().add(i - firstDay, "d"); });
        table.push(firstWeek);
        var nextWeekFirst = firstWeek[6].clone().add(1, "d");
        while (nextWeekFirst.month() === month) {
            var week = Array(7)
                .fill(null)
                .map(function (_, i) { return nextWeekFirst.clone().add(i, "d"); }); // eslint-disable-line no-loop-func
            table.push(week);
            nextWeekFirst = week[6].clone().add(1, "d");
        }
        return table;
    }
    function renderYear() {
        return (React.createElement("a", { className: "op-item", onClick: function () { return onTypeChange("year"); } }, current.format(t.yearFormat)));
    }
    function renderMonth() {
        return (React.createElement("a", { className: "op-item", onClick: function () { return onTypeChange("month"); } }, moment.monthsShort(month)));
    }
    var _g = __read(range || [null, null], 2), rangeMin = _g[0], rangeMax = _g[1];
    function isValidDate(date) {
        // 非 RangePicker
        if (typeof dateRangeInRangePicker === "undefined") {
            if (moment.isMoment(rangeMin) && isAfter(rangeMin, date, "day")) {
                return false;
            }
            if (moment.isMoment(rangeMax) && isBefore(rangeMax, date, "day")) {
                return false;
            }
        }
        else {
            // RangePicker
            var _a = __read(dateRangeInRangePicker, 2), aRangeMin = _a[0], aRangeMax = _a[1];
            if (moment.isMoment(aRangeMin) && isAfter(aRangeMin, date, "day")) {
                return false;
            }
            if (moment.isMoment(aRangeMax) && isBefore(aRangeMax, date, "day")) {
                return false;
            }
        }
        return disabledDate(date);
    }
    return (React.createElement(Table, { caption: t.monthBeforeYear ? (React.createElement(React.Fragment, null,
            renderMonth(),
            renderYear())) : (React.createElement(React.Fragment, null,
            renderYear(),
            renderMonth())), jumperOptions: {
            onNext: function () {
                return onCurrentChange(moment(current).add(1, "month"), { from: "jumper" });
            },
            onPrev: function () {
                return onCurrentChange(moment(current).subtract(1, "month"), {
                    from: "jumper",
                });
            },
            onCurrent: function () { return onCurrentChange(now, { from: "jumper" }); },
            isCurrent: isSame(current, now, "month"),
            nextDisabled: moment.isMoment(rangeMax) &&
                isBefore(rangeMax, moment(current)
                    .set({
                    date: 1,
                })
                    .add(1, "month"), "day"),
            prevDisabled: moment.isMoment(rangeMin) &&
                isAfter(rangeMin, moment(current)
                    .set({
                    date: 1,
                })
                    .subtract(1, "day"), "day"),
            nextTitle: t.nextMonth,
            prevTitle: t.prevMonth,
            curTitle: t.curMonth,
        } },
        React.createElement("div", { className: classPrefix + "-calendar__header-group" },
            React.createElement("div", { className: classPrefix + "-calendar__row" }, moment.weekdaysMin().map(function (name) { return (React.createElement(Table.Cell, { key: name, name: name })); }))),
        genTable().map(function (week, i) { return (React.createElement(Table.Row, { key: month + "-" + i }, week.map(function (date, j) { return (React.createElement(Table.Cell, { key: month + "-" + i + "-" + j, name: date.date(), value: date, onSelect: onSelect, status: cellStatus(date), isNow: isSame(date, now, "day"), outside: date.month() !== month, disabled: !isValidDate(date), onOutsideSelect: function (date) {
                return onCurrentChange(date.clone(), { from: "outside-date" });
            }, onHoveredChange: onHoveredChange, dateRender: dateRender })); }))); })));
}
DateTable.displayName = "DateTable";
//# sourceMappingURL=DateTable.js.map